"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Base_1 = __importDefault(require("./Base"));
var BleedGuides = /** @class */ (function (_super) {
    __extends(BleedGuides, _super);
    function BleedGuides(props) {
        var _this = _super.call(this, props) || this;
        _this.enabled = false;
        _this.guideConfig = null;
        _this.initBleedGuides(_this.canvas);
        return _this;
    }
    BleedGuides.prototype.setEnabled = function (enabled) {
        this.enabled = enabled;
    };
    BleedGuides.prototype.setConfig = function (config) {
        this.guideConfig = config;
    };
    BleedGuides.prototype.initBleedGuides = function (canvas) {
        var ctx = canvas.getSelectionContext();
        var self = this;
        canvas.on("after:render", function () {
            if (!self.enabled || !self.guideConfig)
                return;
            self.draw(canvas, ctx);
        });
    };
    BleedGuides.prototype.draw = function (canvas, ctx) {
        var _a, _b;
        var config = this.guideConfig;
        var vt = canvas.viewportTransform;
        if (!vt)
            return;
        // Find the Frame object to get its position on the canvas.
        // All guide coordinates are relative to the frame's top-left corner.
        var frameObj = canvas.getObjects().find(function (o) { return o.type === 'Frame'; });
        var frameLeft = (_a = frameObj === null || frameObj === void 0 ? void 0 : frameObj.left) !== null && _a !== void 0 ? _a : 0;
        var frameTop = (_b = frameObj === null || frameObj === void 0 ? void 0 : frameObj.top) !== null && _b !== void 0 ? _b : 0;
        // Transform frame-local coordinates → screen pixel coordinates
        // fabric viewport transform: screenX = canvasX * vt[0] + vt[4]
        var tx = function (localX) { return (frameLeft + localX) * vt[0] + vt[4]; };
        var ty = function (localY) { return (frameTop + localY) * vt[3] + vt[5]; };
        if (config.type === 'inside') {
            this.drawInsideGuides(ctx, tx, ty, config);
        }
        else {
            this.drawCoverGuides(ctx, tx, ty, config);
        }
    };
    BleedGuides.prototype.drawInsideGuides = function (ctx, tx, ty, config) {
        var bleedPx = config.bleedPx, frameWidth = config.frameWidth, frameHeight = config.frameHeight, showCenterLine = config.showCenterLine, _a = config.showSpineGuides, showSpineGuides = _a === void 0 ? false : _a, _b = config.showSafeZone, showSafeZone = _b === void 0 ? true : _b;
        if (showSafeZone) {
            // Safe zone rectangle inset by bleed from all edges
            this.drawDashedRect(ctx, tx, ty, bleedPx, bleedPx, frameWidth - bleedPx, frameHeight - bleedPx, 'rgba(255, 0, 0, 0.5)');
        }
        // Center fold line for layflat spreads
        if (showCenterLine && showSpineGuides) {
            var centerX = frameWidth / 2;
            this.drawDashedLine(ctx, tx, ty, centerX, 0, centerX, frameHeight, 'rgba(0, 0, 0, 0.5)');
        }
    };
    BleedGuides.prototype.drawCoverGuides = function (ctx, tx, ty, config) {
        var bleedPx = config.bleedPx, frameWidth = config.frameWidth, frameHeight = config.frameHeight, _a = config.spinePx, spinePx = _a === void 0 ? 0 : _a, _b = config.creasePx, creasePx = _b === void 0 ? 0 : _b, _c = config.showSpineGuides, showSpineGuides = _c === void 0 ? false : _c, _d = config.showSafeZone, showSafeZone = _d === void 0 ? true : _d;
        var coverHalfW = Math.round((frameWidth - spinePx) / 2);
        if (showSafeZone) {
            // Back panel safe zone
            this.drawDashedRect(ctx, tx, ty, bleedPx, bleedPx, coverHalfW - creasePx, frameHeight - bleedPx, 'rgba(255, 0, 0, 0.5)');
            // Front panel safe zone
            this.drawDashedRect(ctx, tx, ty, coverHalfW + spinePx + creasePx, bleedPx, frameWidth - bleedPx, frameHeight - bleedPx, 'rgba(255, 0, 0, 0.5)');
        }
        if (showSpineGuides) {
            // Spine boundaries (vertical lines)
            this.drawDashedLine(ctx, tx, ty, coverHalfW, 0, coverHalfW, frameHeight, 'rgba(0, 100, 255, 0.5)');
            this.drawDashedLine(ctx, tx, ty, coverHalfW + spinePx, 0, coverHalfW + spinePx, frameHeight, 'rgba(0, 100, 255, 0.5)');
            // Crease boundaries (vertical lines)
            if (creasePx > 0) {
                this.drawDashedLine(ctx, tx, ty, coverHalfW - creasePx, 0, coverHalfW - creasePx, frameHeight, 'rgba(255, 165, 0, 0.5)');
                this.drawDashedLine(ctx, tx, ty, coverHalfW + spinePx + creasePx, 0, coverHalfW + spinePx + creasePx, frameHeight, 'rgba(255, 165, 0, 0.5)');
            }
        }
    };
    BleedGuides.prototype.drawDashedRect = function (ctx, tx, ty, left, top, right, bottom, color) {
        ctx.save();
        ctx.setLineDash([8, 4]);
        ctx.lineWidth = 1.5;
        ctx.strokeStyle = color;
        ctx.beginPath();
        ctx.moveTo(tx(left), ty(top));
        ctx.lineTo(tx(right), ty(top));
        ctx.lineTo(tx(right), ty(bottom));
        ctx.lineTo(tx(left), ty(bottom));
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    };
    BleedGuides.prototype.drawDashedLine = function (ctx, tx, ty, x1, y1, x2, y2, color) {
        ctx.save();
        ctx.setLineDash([8, 4]);
        ctx.lineWidth = 1.5;
        ctx.strokeStyle = color;
        ctx.beginPath();
        ctx.moveTo(tx(x1), ty(y1));
        ctx.lineTo(tx(x2), ty(y2));
        ctx.stroke();
        ctx.restore();
    };
    return BleedGuides;
}(Base_1.default));
exports.default = BleedGuides;
//# sourceMappingURL=BleedGuides.js.map